module.exports = __webpack_public_path__ + "img/20.8c9e12be.svg";